<template>
    <div class="ip‑whitelist‑wrap">
      <!-- 查询筛选 -->
      <div class="search‑card">
        <el-form :model="queryForm" inline>
          <el-form-item label="机构名称">
            <el-input
              v-model="queryForm.companyName"
              placeholder="输入机构名称"
              clearable
              @keyup.enter="getMainList"
            />
          </el-form-item>
          <el-form-item label="IP地址">
            <el-input
              v-model="queryForm.ip"
              placeholder="输入IP地址"
              clearable
              @keyup.enter="getMainList"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getMainList">查询</el-button>
            <el-button @click="handleReset">重置</el-button>
            <el-button type="success" @click="openAddDialog">新增IP白名单</el-button>
          </el-form-item>
        </el-form>
      </div>
  
      <!-- 表格区域 -->
      <div class="table‑card">
        <el-table
          :data="tableData"
          border
          stripe
          v-loading="loading"
          style="width:100%"
        >
          <el-table-column label="ID" prop="id" align="center" width="80" />
          <el-table-column label="机构ID" prop="company_id" align="center" width="120" />
          <el-table-column label="机构名称" prop="company_name" align="left" min-width="280" />
          <el-table-column label="IP地址" prop="ip" align="center" min-width="180" />
          <el-table-column label="操作" align="center" width="140">
            <template #default="scope">
              <el-button type="danger" link size="small" @click="handleDelete(scope.row)">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
  
        <el-pagination
          v-model:current-page="pagination.page"
          v-model:page-size="pagination.pageSize"
          :total="pagination.total"
          :page-sizes="[10, 20, 50, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="getMainList"
          @current-change="getMainList"
          class="mt‑4"
        />
      </div>
  
      <!-- 新增弹窗 -->
      <el-dialog
        v-model="addDialogVisible"
        title="新增IP白名单"
        width="520px"
        :close-on-click-modal="false"
      >
        <el-form ref="addFormRef" :model="addForm" label-width="110px">
          <el-form-item label="机构ID" prop="company_id" required>
            <el-input-number v-model="addForm.company_id" :min="1" style="width:100%" placeholder="请输入机构ID" />
          </el-form-item>
          <el-form-item label="IP地址" prop="ip" required>
            <el-input v-model="addForm.ip" placeholder="例如：127.0.0.1" />
          </el-form-item>
        </el-form>
        <template #footer>
          <el-button @click="addDialogVisible = false">取消</el-button>
          <el-button type="primary" :loading="submitLoading" @click="handleSubmitAdd">确定新增</el-button>
        </template>
      </el-dialog>
    </div>
  </template>
  
  <script setup>
  import { ref, reactive, onMounted } from "vue";
  import { ElMessage, ElMessageBox } from "element-plus";
  import { getiplist, addip, delip } from "@/api/api";
  
  const loading = ref(false);
  const submitLoading = ref(false);
  const addDialogVisible = ref(false);
  const addFormRef = ref(null);
  
  const queryForm = reactive({
    companyName: "",
    ip: ""
  });
  
  const pagination = reactive({
    page: 1,
    pageSize: 10,
    total: 0
  });
  
  const tableData = ref([]);
  
  const addForm = reactive({
    company_id: null,
    ip: ""
  });
  
  //获取IP白名单列表
  const getMainList = async () => {
    loading.value = true;
    try {
      const params = {
        page: pagination.page,
        pageSize: pagination.pageSize
      };
      const res = await getiplist(params);
      if (res.code === 200) {
        tableData.value = res.data.list || [];
        pagination.total = res.data.total || 0;
      } else {
        ElMessage.error(res?.message || "获取IP白名单列表失败");
      }
    } catch (err) {
      ElMessage.error("接口请求异常");
    } finally {
      loading.value = false;
    }
  };
  
  //打开新增弹窗
  const openAddDialog = () => {
    addForm.company_id = null;
    addForm.ip = "";
    addDialogVisible.value = true;
  };
  
  //提交新增
  const handleSubmitAdd = async () => {
    if (!addForm.company_id) {
      ElMessage.warning("请填写机构ID");
      return;
    }
    if (!addForm.ip) {
      ElMessage.warning("请填写IP地址");
      return;
    }
    submitLoading.value = true;
    try {
      const payload = {
        company_id: addForm.company_id,
        ip: addForm.ip
      };
      const res = await addip(payload);
      if (res.code === 200) {
        ElMessage.success("新增IP白名单成功");
        addDialogVisible.value = false;
        getMainList();
      } else {
        ElMessage.error(res?.message || "新增失败");
      }
    } catch (e) {
      ElMessage.error("接口请求异常");
    } finally {
      submitLoading.value = false;
    }
  };
  
  //删除
  const handleDelete = (row) => {
    ElMessageBox.confirm(
      `确定删除该IP【${row.ip}】白名单记录？删除后该机构此IP将无法访问接口`,
      "风险提示",
      { confirmButtonText: "确认", cancelButtonText: "取消", type: "warning" }
    ).then(async () => {
      const res = await delip({ id: row.id });
      if (res.code === 200) {
        ElMessage.success("删除成功");
        getMainList();
      } else {
        ElMessage.error(res?.message || "删除失败");
      }
    }).catch(() => {});
  };
  
  //重置
  const handleReset = () => {
    queryForm.companyName = "";
    queryForm.ip = "";
    pagination.page = 1;
    getMainList();
  };
  
  onMounted(() => {
    getMainList();
  });
  </script>
  
  <style scoped>
  .ip‑whitelist‑wrap {
  }
  .search‑card {
    background: #fff;
    padding: 16px;
    border-radius: 6px;
    margin-bottom: 16px;
  }
  .table‑card {
    background: #fff;
    padding: 16px;
    border-radius: 6px;
  }
  .mt‑4 {
    margin-top: 16px;
  }
  </style>
  